export function createRandomString({ prefix } = { prefix: "" }) {
  return (
    prefix?.toString() +
    "_" +
    Math.random()
      .toString()
      .substring(2)
  );
}
